import { render } from "./TextWithLinks.vue?vue&type=template&id=b136d622&scoped=true"
import script from "./TextWithLinks.vue?vue&type=script&lang=js"
export * from "./TextWithLinks.vue?vue&type=script&lang=js"

import "./TextWithLinks.vue?vue&type=style&index=0&id=b136d622&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b136d622"]])

export default __exports__